var _Defs, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, G, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgChevronDownCircled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "chevronDownCircled_svg__Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)), _G || (_G = /*#__PURE__*/React.createElement(G, {
    id: "chevronDownCircled_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement(Path, {
    className: "chevronDownCircled_svg__cls-1",
    d: "M20.08 24.64l7-7-1.41-1.41-5.6 5.59-5.59-5.59-1.42 1.41 7 7h.02z"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "chevronDownCircled_svg__cls-1",
    d: "M20 1c10.48 0 19 8.52 19 19s-8.52 19-19 19S1 30.48 1 20 9.52 1 20 1m0-1C8.95 0 0 8.95 0 20s8.95 20 20 20 20-8.95 20-20S31.05 0 20 0z"
  }))));
}
export default SvgChevronDownCircled;